import React from 'react'

const Footer = () => {
  return (
    <div id='footer'>
        <p>Ⓒ Copyright 2023. Knight Bite Foods Pvt. Ltd. All Rights Reserved</p> 
    </div>
  )
}

export default Footer